import { useSyncExternalStore } from 'react';

/** Tailwind's `lg`: from here up there's room to show things expanded that fold away on smaller screens. */
const LARGE_QUERY = '(min-width: 1024px)';

function getIsLarge() {
  return typeof window !== 'undefined' && window.matchMedia(LARGE_QUERY).matches;
}

function subscribe(onChange: () => void) {
  const mql = window.matchMedia(LARGE_QUERY);
  mql.addEventListener('change', onChange);
  return () => mql.removeEventListener('change', onChange);
}

/** SF-T-266: a large screen (1024px and wider), as the window changes. */
export function useIsLargeScreen(): boolean {
  return useSyncExternalStore(subscribe, getIsLarge, () => true);
}
